import React from 'react';
import styles from './styles.module.css';

export const FieldLabel: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div className={styles.label}>{children}</div>;
